// extracted by mini-css-extract-plugin
var _1 = "IconInputStyle-module__icon___VKMz6";
var _2 = "IconInputStyle-module__icon-input___fS0uK";
var _3 = "IconInputStyle-module__icon-input___fS0uK";
var _4 = "IconInputStyle-module__labeled___hupBT";
export { _1 as "icon", _2 as "icon-input", _3 as "iconInput", _4 as "labeled" }
